interface CityState {
  city?: string | null;
  state?: string | null;
}

const getCityStateNameFromLocation = (cityState: CityState | null): string => {
  const { city, state } = cityState || {};

  if (!city) {
    return '';
  }

  return `${city}${state ? `/${state}` : ''}`;
};
export default getCityStateNameFromLocation;
